<script setup lang="ts">
import "@maersk-global/mds-components-core/mc-menu";
import "@maersk-global/mds-components-core/mc-button";
import "@maersk-global/mds-components-core/mc-list";
import "@maersk-global/mds-components-core/mc-list-item";
import { useGlobalStore } from "@/store/global";

const globalStore = useGlobalStore();

const signOut = () => {
  window.location.href = "/logout";
};
</script>

<template>
  <div class="user-menu">
    <span class="user-menu__name">{{ globalStore.userName }}</span>
    <mc-menu trigger="hover" position="bottom-right">
      <mc-button
        slot="trigger"
        appearance="neutral"
        fit="small"
        hiddenlabel
        icon="user-circle"
        label=""
        variant="plain"
      />
      <mc-list>
        <mc-list-item label="Sign out" icon="door-arrow-right" @click="signOut" />
      </mc-list>
    </mc-menu>
  </div>
</template>

<style scoped lang="scss">
.user-menu {
  display: flex;
  align-items: center;
  gap: 8px;

  &__name {
    font-size: 13px;
    font-weight: 400;
    color: #333;
  }
}
</style>
